import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import YourEntries from 'profile/components/your_entries';

const mapStateToProps = ({ user }, { params }) => {
  const urlBase = `/users/${params.profileUsername}/your-entries/`;
  const tabs = {
    links: []
  };
  if (!!user.profile_data.image_entries_count) {
    tabs.links.push({
      url: `${urlBase}image/`,
      name: 'designs',
    });
  }
  if (!!user.profile_data.name_entries_count) {
    tabs.links.push({
      url: `${urlBase}name/`,
      name: 'names',
    });
  }

  return {
    tabs
  };
}

export default withRouter(connect(mapStateToProps)(YourEntries));



// WEBPACK FOOTER //
// ./profile/containers/your_entries/index.js